import createParseMiddleware from './createParseMiddleware';
import { VisitorSearch } from 'types/visitorSearchTypes';
import { parseVisitorSearchResponse } from 'utils/apiParser/visitorSearchParser';

export const parseSearchVisitorsMiddleware = createParseMiddleware<VisitorSearch>(parseVisitorSearchResponse, 'visitorSearch/searchVisitors');